import React from 'react';
import MarkdownPageRenderer from '../../componentsV2/MarkdownPageRenderer/MarkdownPageRenderer';
import PrivacyPolicyMarkdown from './privacyPolicyMarkdown.md';

const PrivacyPolicyPage = () => {
  return <MarkdownPageRenderer MarkdownContent={PrivacyPolicyMarkdown} />;
};

export default PrivacyPolicyPage;
